export default "__VITE_ASSET__B6X5Fghl__"